export const AllOrganisationRoles = [
  'ACCOUNT_OWNER',
  'ACCOUNT_VIEWER',
  'USER',
  'DEVELOPER',
  'COMPANY_ADMIN',
]

export type OrganisationRole = typeof AllOrganisationRoles[number]

export type UserRole = {
  roleName: OrganisationRole
  companyIds: number[]
}
